import React from 'react';

function ArtistReservationPending() {
  return (
    <div className="arm-pending-section">
      <h3>예약중 리스트</h3>
      {/* 예약중(대기/확정/취소 등) 리스트 데이터 렌더링 예정 */}
      <ul>
        <li>대기중 예약 1</li>
        <li>확정 예약 2</li>
        <li>취소 예약 3</li>
      </ul>
    </div>
  );
}

export default ArtistReservationPending; 